import type { UserMiniEntity } from "@/features/user/domain/entities/UserMiniEntity";

export class CouponRevelationFilterEntity {
    id!: number ;
    reveledDate?: string[];
    user?: UserMiniEntity | null;
    page?: number;
    limit?: number;
}
